// Market schedules in UTC
const MARKET_SCHEDULES = {
  crypto: { always: true },
  forex: {
    weekly: true,
    openDay: 1,
    closeDay: 5,
    closeHour: 22,
    closeName: 'Forex closes Friday 22:00 UTC',
  },
  metal: {
    weekly: true,
    openDay: 1,
    closeDay: 5,
    closeHour: 21,
    closeName: 'Metals close Friday 21:00 UTC',
  },
  commodity: {
    weekly: true,
    openDay: 1,
    closeDay: 5,
    closeHour: 22,
    closeName: 'Commodities close Friday 22:00 UTC',
  },
  stock: {
    daily: true,
    days: [1, 2, 3, 4, 5],
    openHour: 13, openMin: 30,
    closeHour: 20, closeMin: 0,
    exchangeName: 'NYSE/NASDAQ',
  },

};

// Per-instrument overrides — covers ALL instruments
const MARKET_OVERRIDES = {
  // ════════════════════════════════════════════════
  // US STOCKS — NYSE/NASDAQ (13:30-20:00 UTC)
  // ════════════════════════════════════════════════
  AAPL:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  MSFT:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  GOOGL:   { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  AMZN:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  TSLA:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  NVDA:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  META:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  NFLX:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  ACB:     { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  ALCOA:   { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  ALIBABA: { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  AMC:     { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  AMEX:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  BAIDU:   { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  BERKB:   { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  BOA:     { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  BOEING:  { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  CATER:   { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  CGC:     { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  CHEVRON: { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  CISCO:   { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  CITI:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  COIN:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  COKE:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  CRON:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  DIS:     { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  EBAY:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  FERRARI: { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  FSOLAR:  { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  GE:      { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  GILD:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  GM:      { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  GS:      { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  IBM:     { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  JNJ:     { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  JPM:     { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  LCID:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  LMT:     { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  LVS:     { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  MCARD:   { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  MCDON:   { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  MMYT:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  MORSTAN: { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  MRNA:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  NIKE:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  NOKIA:   { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  PAYPAL:  { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  PEP:     { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  PFIZER:  { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  PG:      { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  QCOM:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },
  SNAPCH:  { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  SONY:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  TOYOTA:  { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  VISA:    { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },

  // ════════════════════════════════════════════════
  // INDIAN ADRs — NYSE/NASDAQ (13:30-20:00 UTC)
  // ════════════════════════════════════════════════
  HDB:  { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  IBN:  { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  INFY: { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  RDY:  { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },
  SIFY: { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NASDAQ' },

  // ════════════════════════════════════════════════
  // INDIAN NSE STOCKS — 03:45-10:00 UTC (09:15-15:30 IST)
  // ════════════════════════════════════════════════
  RELIANCE:    { daily:true, days:[1,2,3,4,5], openHour:3,openMin:45, closeHour:10,closeMin:0, exchangeName:'NSE India' },
  BHARTIARTL:  { daily:true, days:[1,2,3,4,5], openHour:3,openMin:45, closeHour:10,closeMin:0, exchangeName:'NSE India' },
  SBIN:        { daily:true, days:[1,2,3,4,5], openHour:3,openMin:45, closeHour:10,closeMin:0, exchangeName:'NSE India' },
  TATAMOTORS:  { daily:true, days:[1,2,3,4,5], openHour:3,openMin:45, closeHour:10,closeMin:0, exchangeName:'NSE India' },
  INDIGO:      { daily:true, days:[1,2,3,4,5], openHour:3,openMin:45, closeHour:10,closeMin:0, exchangeName:'NSE India' },
  ADANIENT:    { daily:true, days:[1,2,3,4,5], openHour:3,openMin:45, closeHour:10,closeMin:0, exchangeName:'NSE India' },
  HAL:         { daily:true, days:[1,2,3,4,5], openHour:3,openMin:45, closeHour:10,closeMin:0, exchangeName:'NSE India' },

  // ════════════════════════════════════════════════
  // INDIAN INDICES — 03:45-10:00 UTC
  // ════════════════════════════════════════════════
  SENSEX:  { daily:true, days:[1,2,3,4,5], openHour:3,openMin:45, closeHour:10,closeMin:0, exchangeName:'BSE India' },
  NIFTY50: { daily:true, days:[1,2,3,4,5], openHour:3,openMin:45, closeHour:10,closeMin:0, exchangeName:'NSE India' },

  // ════════════════════════════════════════════════
  // EURONEXT BRUSSELS (.BR) — 08:00-16:30 UTC
  // ════════════════════════════════════════════════
  ACKERM:   { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Brussels' },
  AGEAS:    { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Brussels' },
  DIETEREN: { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Brussels' },
  KBC:      { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Brussels' },
  UMICOR:   { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Brussels' },

  // ════════════════════════════════════════════════
  // XETRA FRANKFURT (.DE) — 08:00-16:30 UTC
  // ════════════════════════════════════════════════
  ADIDAS:  { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'XETRA Frankfurt' },
  ALLI:    { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'XETRA Frankfurt' },
  BAYER:   { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'XETRA Frankfurt' },
  BMW:     { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'XETRA Frankfurt' },
  COMMBK:  { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'XETRA Frankfurt' },
  DAIM:    { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'XETRA Frankfurt' },
  DBFRA:   { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'XETRA Frankfurt' },
  DTELE:   { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'XETRA Frankfurt' },
  EOAN:    { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'XETRA Frankfurt' },
  SIE:     { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'XETRA Frankfurt' },
  VOWGEN:  { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'XETRA Frankfurt' },

  // ════════════════════════════════════════════════
  // EURONEXT PARIS (.PA) — 08:00-16:30 UTC
  // ════════════════════════════════════════════════
  AXA:      { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Paris' },
  BNPEU:    { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Paris' },
  CAP:      { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Paris' },
  CARREF:   { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Paris' },
  LVMH:     { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Paris' },
  MCHLIN:   { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Paris' },
  RENAULT:  { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Paris' },
  SGOBAIN:  { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Paris' },
  SNFEUR:   { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Paris' },
  SOCIETE:  { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Paris' },
  TOTAL:    { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Paris' },
  VALLOU:   { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Paris' },
  VINCI:    { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Euronext Paris' },

  // ════════════════════════════════════════════════
  // BORSA ITALIANA (.MI) — 08:00-16:30 UTC
  // ════════════════════════════════════════════════
  BUZZI:   { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Borsa Italiana' },
  ENI:     { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Borsa Italiana' },
  INTESA:  { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Borsa Italiana' },
  UNISPA:  { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'Borsa Italiana' },

  // ════════════════════════════════════════════════
  // BME MADRID (.MC) — 08:00-16:30 UTC
  // ════════════════════════════════════════════════
  BBVA:    { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'BME Madrid' },
  BSANMD:  { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'BME Madrid' },
  IBER:    { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'BME Madrid' },
  REPSOL:  { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'BME Madrid' },
  TELFON:  { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'BME Madrid' },

  // ════════════════════════════════════════════════
  // LONDON STOCK EXCHANGE (.L) — 08:00-16:30 UTC
  // ════════════════════════════════════════════════
  LLOY: { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'London Stock Exchange' },
  RR:   { daily:true, days:[1,2,3,4,5], openHour:8,openMin:0, closeHour:16,closeMin:30, exchangeName:'London Stock Exchange' },

  // ════════════════════════════════════════════════
  // SAP — NYSE ADR (13:30-20:00 UTC)
  // ════════════════════════════════════════════════
  SAP: { daily:true, days:[1,2,3,4,5], openHour:13,openMin:30, closeHour:20,closeMin:0, exchangeName:'NYSE' },

  // ════════════════════════════════════════════════
  // INDICES
  // ════════════════════════════════════════════════
 
};

export const getMarketStatus = (instrumentId, category) => {
  const schedule = MARKET_OVERRIDES[instrumentId] || MARKET_SCHEDULES[category];
  
  if (!schedule) return { open: true, reason: '' };
  if (schedule.always) return { open: true, reason: '' };
  
  const now = new Date();
  const dayUTC = now.getUTCDay();
  const hourUTC = now.getUTCHours();
  const minUTC = now.getUTCMinutes();
  const nowMins = hourUTC * 60 + minUTC;
  
  // Weekly schedule (forex, metals, commodities)
  if (schedule.weekly) {
    if (dayUTC === 0 || dayUTC === 6) {
      return { open: false, reason: 'Weekend — market reopens Monday 00:00 UTC', nextOpen: 'Monday 00:00 UTC' };
    }
    if (dayUTC === 5 && hourUTC >= schedule.closeHour) {
      return { open: false, reason: 'Weekend — market reopens Monday 00:00 UTC', nextOpen: 'Monday 00:00 UTC' };
    }
    return { open: true, reason: '' };
  }
  
  // Daily schedule (stocks, indices)
  if (schedule.daily) {
    const openMins = schedule.openHour * 60 + (schedule.openMin || 0);
    const closeMins = schedule.closeHour * 60 + (schedule.closeMin || 0);
    
    if (!schedule.days.includes(dayUTC)) {
      const nextDay = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][schedule.days[0]];
      return {
        open: false,
        reason: `${schedule.exchangeName} is closed on weekends`,
        nextOpen: `${nextDay} ${String(schedule.openHour).padStart(2, '0')}:${String(schedule.openMin || 0).padStart(2, '0')} UTC`,
      };
    }
    if (nowMins < openMins) {
      return {
        open: false,
        reason: `${schedule.exchangeName} opens at ${String(schedule.openHour).padStart(2, '0')}:${String(schedule.openMin || 0).padStart(2, '0')} UTC`,
        nextOpen: `Today ${String(schedule.openHour).padStart(2, '0')}:${String(schedule.openMin || 0).padStart(2, '0')} UTC`,
      };
    }
    if (nowMins >= closeMins) {
      return {
        open: false,
        reason: `${schedule.exchangeName} closed — reopens tomorrow at ${String(schedule.openHour).padStart(2, '0')}:${String(schedule.openMin || 0).padStart(2, '0')} UTC`,
        nextOpen: `Tomorrow ${String(schedule.openHour).padStart(2, '0')}:${String(schedule.openMin || 0).padStart(2, '0')} UTC`,
      };
    }
    return { open: true, reason: '' };
  }
  
  return { open: true, reason: '' };
};

export const getMarketStatusBadge = (instrumentId, category) => {
  const status = getMarketStatus(instrumentId, category);
  if (status.open) {
    return { label: 'OPEN', color: 'var(--gr)', bg: 'rgba(16,185,129,0.12)', border: 'rgba(16,185,129,0.3)' };
  }
  return { label: 'CLOSED', color: 'var(--re)', bg: 'rgba(239,68,68,0.12)', border: 'rgba(239,68,68,0.3)' };
};

export const isMarketOpen = (instrumentId, category) => {
  return getMarketStatus(instrumentId, category).open;
};